import React, { FC, useMemo } from 'react';
import {
  isSolutionWithSubContent,
  Solution,
  SolutionAnswer,
  SolutionSubContent,
} from '../../../../../../config/api/models/Solutions';
import { useTranslation } from 'react-i18next';
import { SolutionsTitle, SolutionsWrapper } from '../Atoms';
import { StudentSolutionSubContent } from './StudentSolutionSubContent';
import StudentAnswerChip from '../answers/StudentAnswerChip';
import { TopLevelQuestionType } from './Atoms';

type SolutionsProps = {
  solution?: Solution;
  inAccordion?: boolean;
};

export const Solutions: FC<SolutionsProps> = ({ solution, inAccordion }) => {
  const { t } = useTranslation();

  const hasSubContent = useMemo(() => {
    if (solution == null) return false;
    if (solution.answers.length === 0) return false;
    return isSolutionWithSubContent(solution.answers[0]);
  }, [solution]);

  const solutionType = useMemo(
    () => solution?.type?.replace('H5P.', '') || 'Undefined',
    [solution]
  );

  return (
    <SolutionsWrapper inAccordion={inAccordion}>
      {!inAccordion && (
        <SolutionsTitle>{t('trajectory.sections.shared.solutions.title')}</SolutionsTitle>
      )}
      {solution == null ? (
        <>{t('trajectory.sections.shared.solutions.noSolutions')}</>
      ) : (
        <>
          {hasSubContent ? (
            <StudentSolutionSubContent
              subContent={solution.answers as SolutionSubContent[]}
              level={0}
              typeTree={[solutionType]}
            />
          ) : solution.answers.length > 0 ? (
            <>
              <TopLevelQuestionType>
                {t(`trajectory.sections.shared.solutions.defaultQuestions.${solutionType}`, {
                  defaultValue: t(
                    'trajectory.sections.shared.solutions.defaultQuestions.Undefined'
                  ),
                })}
              </TopLevelQuestionType>
              {(solution.answers as SolutionAnswer[])
                .filter((solutionAnswer) => solutionAnswer.correct)
                .map((solutionAnswer, solutionAnswerIndex) => (
                  <StudentAnswerChip
                    key={solutionAnswerIndex}
                    answer={solutionAnswer.text}
                    correct
                    grey={false}
                  />
                ))}
            </>
          ) : (
            <>{t('trajectory.sections.shared.solutions.noSolutions')}</>
          )}
        </>
      )}
    </SolutionsWrapper>
  );
};
